import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAddons } from './addons';

/** Sections of the old Site page that now live in Site settings. */
const SETTINGS_SECTIONS = new Set([
  'visibility',
  'identity',
  'domain',
  'analytics',
  'verification',
  'feeds',
  'content-types',
]);

/**
 * /site was one page; its look is now Content → Design and the rest is Site
 * settings. Old links (and agents told "/site#analytics") land in the right one.
 */
export function SiteRedirect() {
  const { hash } = useLocation();
  const section = hash.replace('#', '');
  return SETTINGS_SECTIONS.has(section) ? (
    <Navigate to={`/site/settings${hash}`} replace />
  ) : (
    <Navigate to="/content?view=design" replace />
  );
}

/** /addons (gone): Atomize if this site has it, else Reach. */
export function AddonsRedirect() {
  const { atomizeOn } = useAddons();
  return <Navigate to={atomizeOn ? '/atomize/research' : '/reach/calendar'} replace />;
}

/**
 * An old address that moved: keeps the query and #section, so shared links
 * (/projects?campaign=…) still open the same thing at the new address.
 */
export function MovedTo({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
